// import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter'

import Typsense from 'typesense'

export const typesenseClient = new Typsense.SearchClient({
  apiKey: process.env.REACT_APP_TYPESENSE_API_PUBLIC_KEY ?? '',
  nodes: [
    {
      host: process.env.REACT_APP_TYPESENSE_HOST ?? '',
      port: 443,
      protocol: 'https',
    },
  ],

  sendApiKeyAsQueryParam: true,

  additionalHeaders: {},
})

export const additionalSearchParameters = {
  query_by: 'name,item_id,online_description,brand,embedding,l1_category,l2_category',
  sort_by: '',
  exclude_fields: 'embedding',
}
